import board1 from '../assets/board1.jpg';
import board2 from '../assets/board2.jpg';
import board3 from '../assets/board3.jpg';
import igniter from '../assets/igniter1.jpg';
import datalogger from '../assets/datalogger1.jpg';

const PROJECTS = [
    {
        id: 1,
        title: 'Igniter Module',
        description: ['Custom igniter with flame sense and I/O',
        'Product functions include spark generation, flame sense, and latch valve operation',
        'Jumper selectable firmware variants',
        'Very low power, 12 or 24V operation'],
        link: 'https://github.com/brabick/rpg',
        image: igniter,
        id: "igniter"
    },
    {
        id: 2,
        title: 'Data Logger',
        description: ['Custom datalogger with Modbus and USB flash drive functionality',
        'Robust and redundant storage for over half a million logs',
        'Simple USB configuration and download functionality',
        'Analog inputs log 0-30V, 0-20mA, or type-K thermocouples',
        'Digital inputs have optional pull ups for dry contact switches',
        'RS232/RS485 Modbus and command line interface',
        'Expansion port for radio communication',
        'Very low power, 12 or 24V operation'],
        link: 'https://github.com/brabick/rpg',
        image: datalogger,
        id: "datalogger"
    },
    {
        id: 3,
        title: 'Data Acquisition System',
        description: ['Designed and built 50Msps data acquisition systems for non- destructive testing',
         'Created low noise amplification and signal conditioning circuitry for high impedance wideband sensors',
         'Wrote FPGA code for digital filters and interfaces with high speed ADC and Ethernet modules'],
        link: 'https://github.com/brabick/rpg',
        image: board1,
        id: "dataAcq"
    },
    {
        id: 4,
        title: 'Embedded Firmware for Scientific Instruments',
        description: ['Designed microcontroller C code and FPGA Verilog code to perform high speed data acquisition and processing\
         system control, and communication for research instruments.', 'Improved automation and documentation, created shared code base\
         with many robust, reusable modules including digital filters, communication peripherals and debugging interfaces.'],
        link: 'https://github.com/brabick/Weather-App',
        image: board2,
        id: "Embedded"
    },
    {
        id: 5,
        title: 'Generic Multiport Communication Product',
        description: ['Designed hardware for low cost, 4 port communication gateway/bridge with RS232/RS485 ports', 
        'Wrote firmware in C on ATxmega for multiple custom firmware installations including Modbus message switching\
        and a legacy ASCII conversion product', 'Involved in development and release of many similar products.'],
        link: 'https://github.com/brabick/Tech-Academy-C-Projects',
        image: board3,
        id: "generic"
    }
];

export default PROJECTS;